<template>
    <div>
        <div
            class="relative"
            :style="{
                paddingRight: `${icon.size.width / 2}px`
            }"
        >
            <img 
                class="object-contain aspect-square"
                :class="widthClass"
            
                :src="image.answer"
            />

            <div
                v-if="index"

                class="flex justify-center items-center absolute top-1/2 right-0 -translate-y-1/2"

                :style="{
                    width           : `${icon.size.width}px`,
                    height          : `${icon.size.height}px`,
                    backgroundImage : backgroundImage
                }"
            >
                <span class="font-bold text-white">{{ index }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import store from '@app/fac-search/state/store'

    const props = defineProps({
        member     : Object,
        index      : Number,
        widthClass : {
            type    : String,
            default : 'w-32'
        }
    })

    const defaultImage = computed(
        () => window.phpVals?.acc?.fac_search?.defaultImage?.url
            ? { answer: window.phpVals.acc.fac_search.defaultImage.url }
            : false
    )

    const image = computed(
        () => (store.memberFieldsForSection('profile-photo', props.member)[0] &&  store.memberFieldsForSection('profile-photo', props.member)[0].answer) ? store.memberFieldsForSection('profile-photo', props.member)[0] :  defaultImage.value
    )

    const icon = computed(() => store.map.icon.value)

    const svg = computed(() => `<svg xmlns="http://www.w3.org/2000/svg" viewBox=" 0 0 ${icon.value.size.width} ${icon.value.size.height}" width="${icon.value.size.width}" height="${icon.value.size.height}"><path d="${store.map.path.value}" fill="${String(icon.value.fillColor).replace('#', '%23')}"></path></svg>`)
    const backgroundImage = computed(() => "url('data:image/svg+xml;utf8," + svg.value + "')")
</script>